import * as React from 'react'
import { Create, SimpleForm, TextInput, required, BooleanInput, useDataProvider, useNotify, useRedirect } from 'react-admin'
import { Box, Typography } from '@mui/material'

export const ProviderGroupCreate = (props) => {
  const dataProvider = useDataProvider()
  const notify = useNotify()
  const redirect = useRedirect()

  const handleSave = async (data) => {
    try {
      // 1. Create Group
      // NOTE: this is an explicit allow-list — any form field not named here is
      // silently dropped on create.
      const groupData = {
        name: data.name,
        adminName: data.adminName,
        adminEmail: data.adminEmail,
        shopifyCompanyName: data.shopifyCompanyName,
        provideReplacementCoupons: data.provideReplacementCoupons ?? false,
      }
      const groupResult = await dataProvider.create('provider-groups', { data: groupData })
      const groupId = groupResult.data.id

      notify('Provider Group successfully created', { type: 'success' })
      redirect('show', 'provider-groups', groupId)
    } catch (error) {
      let errorMessage = 'Failed to create provider group.'

      if (error.response.data.message) {
        errorMessage = error.response.data.message
      } else if (error.response.data.error) {
        errorMessage = error.response.data.error
      } else if (error.message) {
        errorMessage = error.message
      }

      notify(errorMessage, { type: 'error', multiLine: true })
    }
  }

  // Pre-fill defaults
  const defaultValues = { provideReplacementCoupons: false }

  return (
    <Create {...props} title="Create New Provider Group">
      <SimpleForm onSubmit={handleSave} defaultValues={defaultValues}>
        <Box width="100%">
          <Typography variant="h6" gutterBottom>
            Provider Group Details
          </Typography>
          <Box display="flex" gap={2}>
            <TextInput source="name" label="Group Name" validate={[required()]} fullWidth />
            <TextInput source="adminName" label="Admin Name" fullWidth />
            <TextInput source="adminEmail" label="Admin Email" type="email" fullWidth />
            <TextInput source="shopifyCompanyName" label="Shopify Company Name" fullWidth />
            <BooleanInput source="provideReplacementCoupons" label="Provide Replacement Coupons" />
          </Box>
        </Box>
      </SimpleForm>
    </Create>
  )
}

export default ProviderGroupCreate
